enum ClientFacingStatus {
  DRAFT = 'DRAFT',
  PRECHECK_PENDING = 'PRECHECK_PENDING',
  RULES_ENGINE_PENDING = 'RULES_ENGINE_PENDING',
  PRECHECK_APPROVED = 'PRECHECK_APPROVED',
  CLOSED = 'CLOSED',
  PRECHECK_FAILED = 'PRECHECK_FAILED',
  RULES_ENG_INCOMPLETE = 'RULES_ENG_INCOMPLETE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED_PAYMENT_REQUIRED = 'APPROVED_PAYMENT_REQUIRED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_EXCEPTION = 'PAYMENT_EXCEPTION',
  APPROVED = 'APPROVED',
  EXPIRED = 'EXPIRED',
  INTERMEDIARY_REJECTED = 'INTERMEDIARY_REJECTED',
  READY_FOR_RENEWAL = 'READY_FOR_RENEWAL',
}

export default ClientFacingStatus;
